import React from 'react'

import SummaryOrder from './SummaryOrder'
import OrderTable from './OrderTable'
import { useIntl } from 'react-intl'
import messages from '../../../../messages'
import ErrorAlert from '@src/routes/Configurators/components/ErrorAlert'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { biTubeConfigContext } from '../../BiTube'

const useStyles = makeStyles((theme: Theme) => {
  return {
    alertMargin: {
      marginLeft: theme.spacing(4),
    },
  }
})

const ConfirmOrder = (props) => {
  const { productDetails, itemDetails } = props
  const classes = useStyles()
  const intl = useIntl()
  const { bitubeState } = React.useContext(biTubeConfigContext)
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const [message, setMessage] = React.useState<string>('')
  const [open, setOpen] = React.useState(false)

  const updateError = (value) => {
    if (value === true || value === false) {
      if (value) {
        setMessage(intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2))
      } else {
        setMessage('')
        setOpen(value)
      }
    } else {
      setOpen(true)
      setMessage(value)
    }
  }

  React.useEffect(() => {
    if (bitubeState.pageError.length) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [bitubeState.pageError])

  return (
    <div>
      <div className={classes.alertMargin}>
        <ErrorAlert open={open} setOpen={setOpen} message={message} />
      </div>
      <OrderTable
        productDetails={productDetails}
        updateError={updateError}
        errorMessage={message}
      />
      <SummaryOrder
        productDetails={productDetails}
        updateError={updateError}
        itemDetails={itemDetails}
      />
    </div>
  )
}

export default ConfirmOrder
